import React from 'react'
import { useSelector } from 'react-redux'
import useInput from '../../hooks/input.hook'
import useFilter from '../../hooks/filter.hook'

import Input from '../../components/UI/Input'
import Filter from '../../components/Filter'
import Amount from '../../components/UI/Amount'
import PartnerSelect from '../../components/PartnerSelect'
import WorkerSelect from '../../components/WorkerSelect'

import * as filterSelectors from '../../redux/selectors/filter.selectors'


function WithdrawFilter() {
    const { setWithdrawsFilter } = useFilter()

    const filter = useSelector(filterSelectors.withdraw)
    const id = useInput(filter.id, (value) => setWithdrawsFilter({id: value}))
    const amount = { min: filter.amount.min, max: filter.amount.max }

    const filterOption = [
        { title: 'Partner', elem: <PartnerSelect value={filter.partner} handler={(option) => setWithdrawsFilter({partner: option.value})} define={true} /> },
        { title: 'Worker', elem: <WorkerSelect value={filter.worker} handler={(option) => setWithdrawsFilter({worker: option.value})} /> },
        { title: 'Amount', elem: <Amount handler={(value) => setWithdrawsFilter({amount: value})} value={amount} /> }
    ]

    return (
        <>
            <Filter option={filterOption} />
            <Input input={id} placeholder='id' />
        </>
    )
}

export default WithdrawFilter